import React from 'react';
import PropTypes from 'prop-types';
import _styles from './styles.module.css';

const ModalCard = ({ children, styles }: any) => (
  <div className={styles.card}>
    { children }
  </div>
);

(ModalCard as any).propTypes = {
  /**
    * The content of the Modal Card, typically one or more ModalBody
    */
  children: PropTypes.node,
  /**
    * The CSS classNames for this component. NEVER manually specify this prop
    */
  styles: PropTypes.shape({}),
};

(ModalCard as any).defaultProps = {
  children: null,
  styles: _styles,
};

(ModalCard as any).displayName = 'ModalCard';

export default ModalCard;
